import {I18N} from './i18n';

export {getMessage, setUpdateRules, FormattedMessage} from './parse';
export {I18N, getSystemLocale, Language, Locale, Messages} from './i18n';

export default I18N;
